var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnyUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24219 1.49219C5.09904 1.49219 1.74219 4.84904 1.74219 8.99219C1.74219 13.1353 5.09904 16.4922 9.24219 16.4922C13.3853 16.4922 16.7422 13.1353 16.7422 8.99219C16.7422 4.84904 13.3853 1.49219 9.24219 1.49219ZM10.2644 6.38231L12.6837 4.9307C13.0345 4.72203 13.4095 5.16356 13.1494 5.47505L12.1333 6.6938L13.1494 7.91255C13.4126 8.22707 13.0315 8.66255 12.6837 8.45691L10.2644 7.00529C10.0315 6.86316 10.0315 6.52445 10.2644 6.38231ZM5.33493 5.47505C5.07485 5.16356 5.44985 4.72203 5.80065 4.9307L8.22001 6.38231C8.4559 6.52445 8.4559 6.86316 8.22001 7.00529L5.80065 8.45691C5.45287 8.66255 5.07485 8.22707 5.33493 7.91255L6.35106 6.6938L5.33493 5.47505ZM13.8057 10.5043C13.5365 12.6515 11.7039 14.3148 9.48412 14.3148H9.00025C6.78049 14.3148 4.94783 12.6515 4.67868 10.5043C4.64239 10.217 4.8692 9.95993 5.15953 9.95993H13.3248C13.6152 9.95993 13.842 10.214 13.8057 10.5043Z",
    fill: "url(#paint0_linear_2785_451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_451",
    x1: 9.24219,
    y1: 1.49219,
    x2: 9.24219,
    y2: 16.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E38C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnyUserActive);
export default __webpack_public_path__ + "static/media/Funny_user_active.8d2ec8b5704730aaf80eee2450a4064d.svg";
export { ForwardRef as ReactComponent };